export default "__VITE_ASSET__BMh86nJm__"